// AUTO-GENERATED FILE. DO NOT EDIT.

import * as nspd_integration from './modules-copy/nspd-integration/index.js';

export const modules = [
  { 
    id: 'nspd-integration', 
    Panel: nspd_integration.Panel, 
    getTools: nspd_integration.getTools,
    ...nspd_integration 
  },
];
